import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CalendarPickerComponent } from '../calendar-picker/calendar-picker.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AsahiOtpModalComponent } from '../asahi-otp-modal/asahi-otp-modal.component';
import { ToastService } from '../../../service/toast.service';
import { LeadService } from '../../../service/lead.service';
import { ClevertapService } from '../../../service/clevertap.service';
import { TranslationService } from '../../../translate.service';
import { AsahiPremiumCalComponent } from '../asahi-premium-cal/asahi-premium-cal.component';
@Component({
  selector: 'app-asahi-whytochoose',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe, AsahiOtpModalComponent, CalendarPickerComponent],
  templateUrl: './asahi-whytochoose.component.html',
  styleUrl: './asahi-whytochoose.component.scss'
})
export class AsahiWhytochooseComponent {
  form!: FormGroup;
  fb = inject(FormBuilder);
  toastService = inject(ToastService);
  leadService = inject(LeadService);

  /** Angular Router service for navigation */
  router = inject(Router);

  /** Selected gender */
  selectedGender: string | null = null;

  /** Selected income */
  selectedIncome!: any;

  /** Controls visibility of gender dropdown */
  showGenderDropdown = false;

  /** Controls visibility of income dropdown */
  showIncomeDropdown = false;

  /** Selected occupation */
  selectedOcuupation: string | null = null;

  /** Controls visibility of occupation dropdown */
  showOccupationDropdown = false;

  /** Selected age */
  selectedAge: string | null = null;

  /** Controls visibility of age dropdown */
  showAgeDropdown = false;

  /** List of gender */
  gender = ['MALE', 'FEMALE'];

  /** List of income */
  income = ['Less than 10 mil', '10 mil to less than 20 mil', '20 mil to less than 30 mil', 'Equal to or more than 30 mil'];

  /** List of ocuupation */
  occupation = ['Office worker', 'Engineer', 'Teacher', 'Driver', 'Freelancer', 'Others'];

  /** List of age */
  age = ['16-19', '20-24', '25-29', '30-34', '35-39', '40-44', '45-49', '50-54', '55-59', '60-64', '65'];

  /** List of last 50 years for car selection */
  years = Array.from({ length: 50 }, (_, i) => (new Date().getFullYear() - i).toString());

  // ---------- OTP & Phone Verification ----------
  /** Controls visibility of OTP modal */
  showOtpModal = false;

  /** Masked phone number for display in OTP modal */
  otpPhoneMasked = '';

  /** Country code for OTP verification */
  otpCountryCode = '84';

  /** Mobile number for OTP verification */
  otpMobileNo = '';

  /** Loading state for OTP actions */
  otpLoading = false;

  /** Error message for OTP verification */
  otpErrorMsg = '';
  lang!: string;
  /** Flag indicating whether the phone is verified */
  phoneVerified: boolean = false;

  /** Stores the verified phone number */
  verifiedPhoneNumber: string = '';

  /** Selected country code for input */
  selectedCountryCode: string = '+84';

  /** List of items */
  items = [
    { title: 'Fits every working individual', img: '/png/UPS-01.png' },
    { title: 'Comprehensive coverage – Extended benefits for critical illnesses', img: '/png/UPS-02.png' },
    { title: 'Affordable premium – Starting from just 3,000 VND per day', img: '/png/UPS-03.png' },
    { title: 'Generous benefits – Up to 1,000,000,000 VND payout', img: '/png/UPS-04.png' },
    { title: 'Quick and simple enrollment – Hassle-free application process', img: '/png/UPS-05.png' },
    { title: 'Nationwide acceptance – Valid at all licensed medical facilities', img: '/png/UPS-06.png' }
  ];

  /** Service to track events via CleverTap */
  clevertapService = inject(ClevertapService);
  source!: any;
  activeDropdown: string | null = null;
  userDetails: any;
  _actRoute = inject(ActivatedRoute);
  private _translationService = inject(TranslationService);
  translateService = inject(TranslateService);
  isLoading: boolean = false;
  @ViewChild('phoneInput') phoneInput!: ElementRef;

  // ---------- Constructor & Form Setup ----------
  constructor(private elementRef: ElementRef, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {
    // Initialize reactive form with validators
    this.form = this.fb.group({
      name: ['', Validators.required],
      type: "income_protection",
      mobileNo: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      yearOfBirth: ['', Validators.required],
      gender: ['', Validators.required],
      averageMonthlyIncome: ['', Validators.required],
      occupation: ['', Validators.required],
      beneficiaryAgeRange: '',
      insuranceFor: [[]],
      consent: [false, Validators.requiredTrue],
      source: ['Website']
    });
  }

  // ngOnInit is a lifecycle hook in Angular
  ngOnInit() {
    this.clevertapService.trackEvent('visited_lead_form', {
      product_type: this.form.get('type')?.value
    });
    const pathSegments = window.location.pathname.split('/').filter(Boolean);

    // Extract 'en' or 'vi' from the route
    const possibleLang = pathSegments[0];
    const supportedLangs = ['en', 'vi'];
    this.lang = supportedLangs.includes(possibleLang) ? possibleLang : 'en';
    this._actRoute.url.subscribe(urlSegments => {
      this.source = urlSegments.some(segment => segment.path === 'mobile')
      if (this.source) {
        this.form.get('source')?.setValue("App");
      }

    });
  }

  toggleDropdown(name: string) {
    this.activeDropdown = this.activeDropdown === name ? null : name;
  }

  closeDropdown() {
    this.activeDropdown = null;
  }
  formatPhone(event: any) {
    let input = event.target.value.replace(/\D/g, '').substring(0, 10);
    const area = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    if (input.length > 6) {
      event.target.value = `(${area}) ${middle}-${last}`;
    } else if (input.length > 3) {
      event.target.value = `(${area}) ${middle}`;
    } else if (input.length > 0) {
      event.target.value = `(${area}`;
    }
    this.form.get('mobileNo')?.setValue(input);

    if (!input.startsWith('0')) {
      this.form.get('mobileNo')?.setErrors({ invalidPhone: true });
    }
    this.cdr.detectChanges();

  }

  onCheckboxChange(event: Event, option: string) {
    const checkbox = event.target as HTMLInputElement;
    const currentValue = this.form.get('insuranceFor')?.value || [];
    if (checkbox.checked) {
      this.form.get('insuranceFor')?.setValue([...currentValue, option]);
    } else {
      this.form.get('insuranceFor')?.setValue(currentValue.filter((val: string) => val !== option));
    }
  }

  get showInsuranceForOthers() {
    const values = this.form.get('insuranceFor')?.value || [];
    return values.includes('FAMILY') || values.includes('FRIENDS') || values.includes('OTHERS');
  }

  selectGender(gen: string) {
    this.selectedGender = gen;
    this.form.get('gender')?.setValue(gen);
    if (this.showGenderDropdown) this.showGenderDropdown = false;
  }

  toggleGenDropdown() {
    this.showGenderDropdown = !this.showGenderDropdown;
  }
  toggleIncomeDropdown() {
    this.showIncomeDropdown = !this.showIncomeDropdown;
  }

  /** Selects a income and updates the form */
  selectIncome(income: String) {
    this.selectedIncome = income;
    this.form.get('averageMonthlyIncome')?.setValue(income);
    this.showIncomeDropdown = false;
    if (this.showIncomeDropdown) this.showIncomeDropdown = false;

  }

  /** Selects a occupation and updates the form */
  selectOcuupation(occupation: string) {
    this.selectedOcuupation = occupation;
    this.form.get('occupation')?.setValue(occupation);
    this.showOccupationDropdown = false;
    if (this.showOccupationDropdown) this.showOccupationDropdown = false;

  }

  /** Selects a age and updates the form */
  selectAge(age: string) {
    this.selectedAge = age;
    this.form.get('beneficiaryAgeRange')?.setValue(age);
    this.showAgeDropdown = false;
    if (this.showAgeDropdown) this.showAgeDropdown = false;

  }

  /** Toggles occupation dropdown visibility */
  toggleOccupationDropdown() {
    this.showOccupationDropdown = !this.showOccupationDropdown;
  }

  /** Toggles age dropdown visibility */
  toggleAgeDropdown() {
    this.showAgeDropdown = !this.showAgeDropdown;

  }

  /** Sets insurance expiry date in the form */
  onDateSelected(selectedDate: string) {
    const selectedYear = Number(selectedDate);
    const currentYear = new Date().getFullYear();
    const control = this.form.get('yearOfBirth');

    if (selectedYear > currentYear) {
      control?.setErrors({ invalidYear: true });
      control?.markAsTouched();
    } else {
      control?.setValue(selectedYear);
      control?.markAsTouched();
      control?.setErrors(null);
    }

  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (target.closest('.dropdown-container')) {
      return;
    }
    this.closeDropdown();

  }

  /** Submits the lead form after validation and triggers phone verification */
  onSubmit() {
    if (this.form.invalid) {
      console.log('Form is invalid');
      this.form.markAllAsTouched();
      return;
    }
    if (!this.form.get('consent')?.value) {
      console.log('Consent is required');
      return;
    }
    if (this.form.get('insuranceFor')?.value.length === 1 && this.form.get('insuranceFor')?.value?.[0] === 'SELF') {
      this.form.get('beneficiaryAgeRange')?.reset();
    }
    this.onVerifyPhone();

  }

  /** Initiates OTP verification for the entered phone number */
  onVerifyPhone() {
    const countryCode = this.selectedCountryCode.replace('+', '') || '84';
    const mobileNo = this.form.get('mobileNo')?.value;
    if (!mobileNo || mobileNo.length < 8) {
      this.toastService.error('Validation Error', 'Please enter a valid phone number before requesting OTP.');
      return;
    }
    this.otpCountryCode = countryCode;
    this.otpMobileNo = mobileNo;
    this.otpLoading = true;
    this.otpErrorMsg = '';
    this.showOtpModal = true;
    const payload = { countryCode, mobileNo };
    console.log(payload);
    this.leadService.sendOtp(payload).subscribe({
      next: (response) => {
        this.otpPhoneMasked = mobileNo;
        this.showOtpModal = true;
        this.otpLoading = false;
      },
      error: (err) => {
        this.otpLoading = false;
        this.otpErrorMsg = 'Invalid OTP. Please try again.';
        this.toastService.showApiError(err, this.otpErrorMsg);
        console.error('OTP verification error:', err);
        // Restore scroll even on error (modal might close)
        document.body.style.overflow = 'auto';
      },
    }).add(() => {
      // Finally block - always executed
      this.otpLoading = false;
      // Ensure scroll is always restored
      document.body.style.overflow = 'auto';
    });
  }

  /** Allows user to edit the phone number after OTP modal is open */
  onOtpEdit() {
    this.showOtpModal = false;
    document.body.style.overflow = 'auto';
    this.form.get('mobileNo')?.enable();
    setTimeout(() => {
      this.phoneInput.nativeElement.focus();
    }, 0);
    this.otpLoading = false;
    this.otpErrorMsg = '';
    this.phoneVerified = false;
    this.verifiedPhoneNumber = '';
  }

  /** Closes OTP modal and resets loading/error states */
  onOtpClosed() {
    this.showOtpModal = false;
    this.otpLoading = false;
    this.otpErrorMsg = '';
    document.body.style.overflow = 'auto';
  }

  /** Dispatches a global event to reset OTP modal */
  resetOtpModal() {
    const resetEvent = new CustomEvent('resetOtpModal');
    window.dispatchEvent(resetEvent);
  }

  /** Handles OTP verification success/failure */
  onOtpVerified(otp: string) {
    this.otpLoading = true;
    this.otpErrorMsg = '';
    const phone = this.otpMobileNo;
    const formatted = phone.replace(/^0/, '');
    const payload = {
      countryCode: this.otpCountryCode,
      mobileNo: formatted,
      otp: otp
    };
    console.log(payload);
    this.leadService.verifyOtp(payload).subscribe({
      next: (response) => {
        this.phoneVerified = true;
        this.verifiedPhoneNumber = this.otpMobileNo;
        this.showOtpModal = false;
        document.body.style.overflow = 'auto';
        if (response) {
          const payload = {
            name: this.form?.get('name')?.value,
            mobileNo: this.form?.get('mobileNo')?.value,
            yearOfBirth: this.form?.get('yearOfBirth')?.value,
            countryCode: this.otpCountryCode,
            type: "INCOME_PROTECTION_INSURANCE",
            source: this.form.get('source')?.value,
            gender: this.form.get('gender')?.value,
            averageMonthlyIncome: this.form.get('averageMonthlyIncome')?.value,
            occupation: this.form.get('occupation')?.value,
            insuranceFor: this.form.get('insuranceFor')?.value,
            beneficiaryAgeRange: this.form.get('beneficiaryAgeRange')?.value || ""
          };
          console.log("payload onopt verified:", payload);
          this.isLoading = true;
          this.leadService.submitLead(payload).subscribe({
            next: (response) => {
              this.isLoading = false;
              console.log(response);

              // Identify user and track submission with details
              const name = payload.name || "";
              const firstName = name.split(" ")[0] || "";
              const lastName = name.split(" ").slice(1).join(" ") || "";
              const phoneNumber = payload.mobileNo || "";
              const countryCode = payload.countryCode || "84";
              const customerId = `${countryCode}-${phoneNumber}`;
              const email = ""; // Email not present in this form

              this.clevertapService.setUserProfile(
                email,
                firstName,
                lastName,
                phoneNumber,
                name
              );

              this.clevertapService.trackEvent('submit_lead_form', {
                product_type: 'income_protection',
                mobileNo: phoneNumber,
                country_code: countryCode,
                customer_id: customerId,
                first_name: firstName,
                last_name: lastName
              });

              const source = this.route.snapshot.queryParamMap.get('source') || '';
              this.router.navigate(
                [`${this.lang}/income-protection-insurance`, 'success-page'],
                {
                  queryParams: { source }
                }
              ).then(() => {
                window.scrollTo(0, 0);
              });
            },
            error: (error) => {
              this.isLoading = false;
              console.error('Error submitting lead:', error);
              this.toastService.error('Error', 'Failed to submit lead. Please try again.');

            },
          }).add(() => {
            this.isLoading = false;
            this.otpLoading = false;
          });
        }
        this.otpLoading = false;
        this.otpErrorMsg = '';
        this.resetOtpModal();
        this.form.reset();
        this.form.get('insuranceFor')?.setValue([]);
        this.form.get('yearOfBirth')?.setValue('');

      },
      error: (err) => {
        this.otpLoading = false;
        this.otpErrorMsg = err.error?.message || 'OTP verification failed. Please try again.';
        console.error('OTP verification error:', err);
      },
    }).add(() => {
      // Finally block - always executed
      this.otpLoading = false;
    });
  }

  scrollToForm() {
    const element = document.getElementById('success');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  /** Sends Zalo OTP */
  onOtpZaloVerify() {
    this.otpLoading = true;
    this.otpErrorMsg = '';
    const phone = this.otpMobileNo;
    const formatted = phone.replace(/^0/, '');
    const payload = { countryCode: this.otpCountryCode, mobileNo: formatted };
    console.log(payload);
    this.leadService.sendZaloOtp(payload).subscribe({
      next: (response: any) => {
        this.otpLoading = false;
        this.toastService.showApiSuccess(response, 'Zalo OTP sent successfully!');
      },
      error: (err: any) => {
        this.otpLoading = false;
        this.otpErrorMsg = 'Failed to send Zalo OTP. Please try again.';
        this.toastService.showApiError(err, this.otpErrorMsg);
        console.error('Zalo OTP send error:', err);
      }
    });
  }

  /** Placeholder for Call OTP verification (not implemented yet) */
  onOtpCallVerify() {
    this.otpLoading = false;
    this.toastService.info('Info', 'Call verification is not implemented yet.');
  }
  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      const scrollToId = params['scrollTo'];
      if (scrollToId) {
        const el = document.getElementById(scrollToId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            this.router.navigate([], {
              queryParams: { scrollTo: null },
              queryParamsHandling: 'merge'
            });
          }, 300);
        }
      }
    });
  }
}
